import React from 'react';
import {Box, IconButton} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import {setLogout} from "../../../store/auth/auth.slice";
import {useAppDispatch} from "../../../store";


const Header = () => {
    const dispatch = useAppDispatch()
    return (
        <>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "primary.dark",
                width: "100%",
                height: "60px",
                color: "secondary.light",
                p: "0 15px"
            }}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px"
                }}>
                    <div>Панель администратора клиники</div>
                </Box>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px"
                }}>
                    <div>Имя пользователя:</div>
                    <div>{localStorage.getItem('user_name')}</div>
                    <IconButton sx={{color: "secondary.light"}} onClick={() => dispatch(setLogout())}>
                        <LogoutIcon/>
                    </IconButton>


                </Box>

            </Box>
        </>
    );
};

export default Header;